<template>
  <div class="home">
    <app-list></app-list>
    <contact-us></contact-us>
  </div>
</template>

<script>

import AppList from  "./AppList"
import ContactUs from "./ContactUs"

export default {
  name: 'Home',
  components: {
    AppList,
    ContactUs
  }
}
</script>

<style lang="scss" scoped>
.home {
}
</style>